import styled, { css } from "styled-components";

import lowPoly from "@/assets/low-poly-grid.png";
import earn from "@/assets/dashboard-home/earn-money.png";
import { styled as muiStyled } from "@mui/material";
import { FutButton } from "@/components/FutButton";
import { customScroll } from "@/styles/globalStyles";

export const HomeContainer = styled.div`
  @media (min-width: 1200px) {
    padding: 10px 45px;
  }

  padding: 10px 10px;
`;

export const FakeNavButton = styled.div`
  @media (min-width: 1200px) {
    display: none;
  }
  display: block;
  position: fixed;
  z-index: 10;
  top: 9px;
  right: 60px;
`;

export const MobileTrophyButton = styled.button`
  display: flex;
  background-color: ${(props) => props.theme.inputColor};
  border: unset;
  border-radius: 5px;
  padding: 12px;
  svg {
    font-size: 1.2rem;
  }
`;

export const GameAnalysis = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0px;
  right: 1px;
  width: 450px;
  height: 90%;
  border-top:solid 10px ${(props) => props.theme.primary};
  background-color: ${(props) => props.theme.topElementsColor};
  z-index: 99;
  border-radius: 5px;
  overflow: hidden;
  overflow-y: ${(props) => (props.isOpen ? "auto" : "hidden")};

  transform: translateY(${(props) => (props.isOpen ? "0%" : "89%")});
  transition: transform 400ms ease-in-out;

  ${customScroll}

  @media (max-width: 1025px) {
    width: 100%;
    height: 100%;

    transform: translateY(${(props) => (props.isOpen ? "0%" : "100%")});
  }
`;

export const MobileBtnAnalysis = styled.button`
  display: none;

  @media (max-width: 1025px) {
    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    bottom: 30px;
    right: 20px;

    width: 55px;
    height: 55px;
    padding: 15px;
    background-color: ${(props) => props.theme.primary};
    border-radius: 100px;
    background: linear-gradient(90deg, #1B73DA 0%,rgb(2, 62, 129) 100%), #fff;
    box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.1);

    z-index: 2;
    svg {
      font-size: 2rem;
    }
  }
`;

export const GameHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  position: sticky;
  top: 0;
  background-color: ${(props) => props.theme.topElementsColor};
  z-index: 99;

  padding: 30px 30px 20px;

  img {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 10px;
  }
`;

export const GameContent = styled.div`
  margin: 0 30px;
`;

export const CloseGame = styled.div`
  text-align: end;
  margin-bottom: 10px;
  user-select: none;
  span {
    padding: 0 6px;
    cursor: pointer;
    background-color: ${(props) => props.theme.topElementsColor};
    border-radius: 3px;
  }
`;

export const GameAnalyticsNotFound = styled.div`
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  text-align: center;
  span {
    svg {
      vertical-align: middle;
    }
  }
`;

export const GameCard = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 25px;
  border-radius: 5px;
  margin: 10px 0;
  transform: translateX(0%);
  transition: all 300ms ease-in-out;
`;

export const GameStatisticsContainer = styled.div`
  margin: 20px 0;
  text-align: center;
`;

export const GameStatistic = styled.div<{
  homePoints: number;
  awayPoints: number;
}>`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  span {
    padding: 0px 4px;
    border-radius: 3px;
  }

  ${(props) =>
    props.homePoints > props.awayPoints
      ? css`
          span:first-child {
            background-color: #325176;
          }
        `
      : props.awayPoints > props.homePoints
        ? css`
          span:last-child {
            background-color: #993232;
          }
        `
        : ""}
`;

export const StatsNotFound = styled.div`
  text-align: center;
  margin: 30px 0;

  p {
    color: ${(props) => props.theme.fontColor}80;
    font-weight: bold;
  }
`;

export const PercentageContainer = styled.div`
  h3 {
    margin: 10px 0;
    text-align: center;
  }
`;

export const OtherOddsContainer = styled.table`
  margin-top: 20px;

  &,
  table,
  th,
  td {
    border: 2px solid ${(props) => props.theme.fontColor};
    border-collapse: collapse;
  }

  tr {
    text-align: left;
  }

  th {
    padding: 10px 5px;
    font-weight: normal;
  }

  td {
    padding: 0px 10px;
  }
`;

export const LeagueContainer = styled.div<{ isOpen: boolean }>`
  padding: 10px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.backgroundColor};

  h2 {
    margin-bottom: 10px;
    span {
      display: none;
    }
  }

  a {
    text-decoration: none;
    color: ${(props) => props.theme.fontColor};
  }

  div:hover {
    background-color: ${(props) => props.theme.inputColor};
  }

  a.active div {
    background-color: ${(props) => props.theme.inputColor};
  }

  img {
    max-width: 100%;
    width: 20px;
  }

  span {
    margin-left: 10px;
  }

  div {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 5px;
    margin-bottom: 10px;
    border-radius: 5px;
  }

  @media only screen and (max-width: 1200px) {
    position: fixed;
    left: 0;
    top: ${(props) => (props.isOpen ? "0%" : "100%")};
    width: 100%;
    height: 100%;
    z-index: 11;
    transition: all 400ms ease-in-out;

    h2 {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      span {
        display: flex;
        text-align: center;
        padding: 0 10px;
        margin-bottom: 15px;
      }
    }
  }
`;

export const GptAnalysis = styled.div`
  position: relative;
  padding: 20px;
  background: linear-gradient(26deg, rgb(0 80 120 / 50%), rgb(1 98 146 / 82%));
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h2 {
    margin-bottom: 10px;
  }
  border-radius: 6px;
`;

export const GptCover = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: url(${lowPoly});
  opacity: 0.3;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -1;
  border-radius: 10px;
`;

export const ReferFriendsContainer = styled.div`
  margin-left: 15px;
  padding: 20px;
  background: url(${earn});
  background-size: cover;
  border-radius: 10px;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  h2 {
    margin-bottom: 10px;
  }
`;

export const GameFilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.backgroundColor};
  margin-top: 15px;
  padding: 10px;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

export const ContainerTabs = styled.div`
  border-bottom: 1px solid;
  border-color: rgba(255, 255, 255, 0.12);
  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const SwitchButton = styled.div`
  position: relative;
  top: 50%;
  width: 310px;
  height: 40px;
  overflow: hidden;
  border-radius: 6px;

  input {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }

  input:checked + div h3 {
    color: #4e4e4e;
  }

  input:checked + div:before {
    left: 165px;
    /* background-color: #f44336; */
  }

  input:checked + div:after {
    color: #fff;
  }

  @media (max-width: 425px) {
    width: 220px;
    input:checked + div:before {
      left: 108px;
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  @media only screen and (max-width: 500px) {
    width: 100%;
    justify-content: center;
  }
`;

export const FilterMobileBtn = styled.button`
  padding: 8px 10px;
  background-color: ${(props) => props.theme.bottomColor};
  border: 2px solid ${(props) => props.theme.inputColor};
  border-radius: 5px;
  &:hover {
    background-color: ${(props) => props.theme.fontColor}10;
  }

  svg {
    font-size: 1.2rem;
  }

  p {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
  @media only screen and (max-width: 500px) {
    width: 100%;
    margin-top: 15px;
  }
`;

export const ModalMobileContainer = styled.div`
  position: absolute;
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalMobileContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 10px;
  h2 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    span {
      cursor: pointer;
      user-select: none;
      padding: 0px 10px;
      margin-right: 10px;
    }
  }
  p {
    margin: 8px 0;
  }
`;

export const ModalMobileBtn = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 32px;
`;

export const KnobButton = styled.div<{ rightName: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  &:before,
  &:after,
  & h3 {
    position: absolute;
    top: 4px;
    width: 130px;
    height: 13px;
    font-family: "Agency FB";
    text-align: center;
    font-weight: lighter;
    line-height: 1;
    letter-spacing: 0.36px;
    padding: 9px 4px;
    border-radius: 2px;
    font-size: 1.17em;
    transition: 0.3s ease all;
  }

  &:before {
    content: "";
    left: 4px;
    background-color: ${(props) => props.theme.selectColor};
  }

  &:after {
    content: "${(props) => props.rightName}";
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    right: 4px;
    top: 0px;
    bottom: 0px;
    color: rgb(78, 78, 78);
    padding: 0;
  }

  div {
    position: absolute;
    width: 10px;
    height: 10px;
    right: 33%;
    top: 0;
    bottom: 0;
    margin: auto 0px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.primary};
    box-shadow: 0 0 15px ${(props) => props.theme.primary};
    opacity: 1;
    animation: blink infinite 4000ms;
  }

  h3 {
    display: inline-block;
    left: 4px;
    color: #fff;
    z-index: 1;
    display: flex;
    align-items: center;
    margin-top: 6px;
    justify-content: center;
  }

  @media (max-width: 425px) {
    &:before,
    &:after,
    & h3 {
      width: 100px;
      font-size: 1.07em;
    }
    div {
      right: 35%;
      top: -1px;
    }
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const LayerSwitch = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  width: 100%;
  background-color: ${(props) => props.theme.bottomColor};
  transition: 0.3s ease all;
  z-index: 1;
`;

export const GameBodyContainer = styled.div`
  padding: 25px;
  background-color: ${(props) => props.theme.backgroundColor};
  margin-top: 15px;

  h2 {
    margin-bottom: 25px;
  }
`;

export const GameCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.bottomColor};
  padding: 25px 15px;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  justify-content: center;
`;

export const GameBackImage = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  img {
    filter: grayscale(100%);
    max-width: 100%;
    width: 100px;
    object-fit: contain;
    opacity: 0.1;
  }
`;

export const GameInfoLive = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  img {
    max-width: 100%;
    width: 60px;
    height: 60px;
    object-fit: contain;
  }
`;

export const GameEndContainer = styled.div`
  text-align: center;
  margin-bottom: 25px;
  span {
    color: red;
    font-weight: bold;
  }
`;

export const GameScore = styled.div`
  flex-grow: 0.5;
  text-align: center;
`;

export const TeamContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 60px;
  small {
    color: rgba(255, 255, 255, 0.6);
  }

  p {
    text-align: center;
    max-width: 125px;
  }
`;

export const StatisticsButton = muiStyled(FutButton)`
  display: flex;
  align-items: center;
  gap: 8px;

  background-color: ${(props) => props.theme.palette.secondary.main}1a;
  padding: 4px 8px;
  border: unset;
  border-radius: 10px;
  color: ${(props) => props.theme.palette.secondary.main};
  margin-top: 15px;

  &:hover {
    border: unset;
  }
`;


export const TelegramButton = muiStyled(FutButton)`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #0088cc;
  padding: 4px 8px;
  border: unset;
  border-radius: 10px;
  color: #fff;
  margin-top: 15px;

  &:hover {
    border: unset;
  }
`;

export const StatisticsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.fontColor}80;
  span {
    font-size: 60px;
    margin-bottom: 10px;
    transform: rotate(90deg);
  }
`;
